/*
   Inject current comoponents.
*/
import camelcase from 'lodash.camelcase'

const requireRoot: any = require.context(".", false, /\.ts$/);
const requireModule: any = require.context(".", true, /\.ts$/);
const modules: any = {};

requireRoot.keys().forEach(fileName => {
    if (fileName === "./index.ts") return;

    const moduleName = camelcase(fileName.replace(/(\.\/|\.ts)/g, ""));
    modules[moduleName] = requireRoot(fileName).default;
});

requireModule.keys().forEach(fileName => {
    const file = fileName.substring(fileName.lastIndexOf("/"));
    
    if (file.indexOf('Index.ts') == -1) return;
   
    const moduleName = camelcase(file.replace(/(\.\/|\.ts)/g, ""));
    const name = moduleName.replace('Index', '');
    modules[moduleName] = requireModule(fileName).default;
});

window.modules = modules;
export default modules;

